module.exports = __webpack_public_path__ + "avatar2.svg?c8c059dfb2ebbdc1ab14850253ae2c75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar2.svg
// module id = 138
// module chunks = 2